<template>
  <v-container>
    <!-- <v-row>
      <v-col cols="12"><GoogleStats /></v-col>
    </v-row> -->
    <v-row>
      <v-col cols="6"><Stimmet :loading="!isInitialized.users"/></v-col>
      <v-col cols="6"
        ><Memo :loading="!isInitialized.memo" v-bind="memo" @memo:update="onMemoUpdate"
      /></v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <LatestNews :loading="!isInitialized.news" :items="newsItems" @news:goto="onClickNews" />
      </v-col>
      <v-col cols="4">
        <LatestReports
          @report:goto="onClickReport"
          :loading="!isInitialized.reports"
          :items="reportItems"
          title="Senaste rapporterna"
        />
      </v-col>
      <v-col cols="4">
        <LatestReports
          @report:goto="onClickReport"
          :loading="!isInitialized.avhandlingar"
          :items="avhandlingarItems"
          title="Senaste avhandlingarna"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import LatestNews from '@/components/news/LatestNews'
import LatestReports from '@/components/reports/LatestReports'
import Stimmet from '@/components/shared/Stimmet'
import GoogleStats from '@/components/shared/GoogleStats'
import Memo from '@/components/shared/Memo'
import { reportTypeUrls } from '@/assets/data/reportTypes'

export default {
  name: 'Start',
  components: {
    LatestNews,
    LatestReports,
    Stimmet,
    GoogleStats,
    Memo,
  },
  data() {
    return {
      isInitialized: {
        news: false,
        reports: false,
        avhandlingar: false,
        memo: false,
        users: false,
      },
    }
  },
  computed: {
    ...mapGetters('news', { newsItems: 'getArray' }),
    ...mapGetters('reports', { reportItems: 'getArray' }),
    ...mapGetters('avhandlingar', { avhandlingarItems: 'getArray' }),
    ...mapGetters('memo', { memo: 'getMemo' }),
  },
  methods: {
    ...mapMutations('news', {
      addNewsFilter: 'ADD_FILTER',
      setNewsOrder: 'SET_SORT',
      clearNewsFilters: 'CLEAR_FILTERS',
    }),
    ...mapMutations('reports', {
      addReportsFilter: 'ADD_FILTER',
      setReportsOrder: 'SET_SORT',
      clearReportsFilters: 'CLEAR_FILTERS',
    }),
    ...mapMutations('avhandlingar', {
      addAvhandlingarFilter: 'ADD_FILTER',
      setAvhandlingarOrder: 'SET_SORT',
      clearAvhandlingarFilters: 'CLEAR_FILTERS',
    }),
    ...mapActions('user', { getUsers: 'readCollection' }),

    onClickNews({ id }) {
      this.$router.push({ name: 'SingleNews', params: { id } })
    },
    onClickReport({ id, article_type }) {
      this.$router.push({
        name: 'SingleReport',
        params: { id, section: reportTypeUrls[article_type] },
      })
    },
    onMemoUpdate(update) {
      this.$store.dispatch('memo/update', { ...this.memo, ...update })
    },
  },
  async created() {
    this.clearNewsFilters()
    this.clearReportsFilters()
    this.clearAvhandlingarFilters()
    this.setNewsOrder({ key: 'news_id', value: 'DESC' })

    this.addReportsFilter({ key: 'article_type', value: ['Lans_rapp', 'orap', 'MC-rapport'] })
    this.setReportsOrder({ key: 'updated_at', value: 'DESC' })

    this.addAvhandlingarFilter({ key: 'article_type', value: ['avhandling'] })
    this.setAvhandlingarOrder({ key: 'updated_at', value: 'DESC' })

    await this.getUsers()
    this.isInitialized.users = true
    await this.$store.dispatch('memo/read')
    this.isInitialized.memo = true
    await this.$store.dispatch('news/readCollection')
    this.isInitialized.news = true
    await this.$store.dispatch('reports/readCollection')
    this.isInitialized.reports = true
    await this.$store.dispatch('avhandlingar/readCollection')
    this.isInitialized.avhandlingar = true
  },
}
</script>

<style lang="less" scoped></style>
